module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      marginTop88: _vm.boxConfig.hasTitle
    },
    attrs: {
      "id": "app"
    }
  }, [(true) ? _c('notice') : _vm._e(), _vm._v(" "), _c('title-box', {
    attrs: {
      "titleBoxConfig": _vm.boxConfig
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": 'vux-pop-' + (_vm.direction === 'forward' ? 'in' : 'out')
    }
  }, [(_vm.$route.meta.keepAlive) ? _c('keep-alive', [_c('router-view')], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (_vm.$route.meta.isScroll != 1) ? _c('keep-alive', [_c('scrollTop')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-09aad170!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1151
// module chunks = 67